import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@itonics/ngx-translate-simple';
import { NgSelectModule } from '@ng-select/ng-select';
@Component({
  selector: 'signals-group-by-dropdown',
  templateUrl: './group-by-dropdown.component.html',
  styleUrls: ['./group-by-dropdown.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, NgSelectModule, FormsModule]
})
export class GroupByDropdownComponent {
  public itemList: Array<string>;

  @Input()
  set list(list: Array<string>) {
    this.itemList = list;
    this.model = this.itemList[0];
  }

  @Output()
  changed: EventEmitter<string> = new EventEmitter();

  public model: string;

  public select(property: string) {
    this.changed.emit(property);
  }
}
